import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=81cd60a2&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cd60a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81cd60a2')) {
      api.createRecord('81cd60a2', component.options)
    } else {
      api.reload('81cd60a2', component.options)
    }
    module.hot.accept("./Article.vue?vue&type=template&id=81cd60a2&scoped=true", function () {
      api.rerender('81cd60a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main-tabs/Article.vue"
export default component.exports